<template>
    <project-step-container
            prev-to="be_rapid_experiments_with_customers_22"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
            :next-disabled="Object.keys(form.option).length === 0"
    >
        <b-row class="first-form">
            <b-col cols="12" class=" simple-text" tabindex="0">
               {{getMessage(23, 'rapidexperiment-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-3 ">
           <b-col cols="12 emotion-content" :key="index" v-for="(option, index) in options">
                <b-button :value="option.key" name="white" variant="secondary" class="square" block
                        v-bind:class="{ active: form.option.key === option.key, isCareerEntrep: isJACareerEntrepreApp } "
                        v-on:click="select(option.key)" >
                            <span class=""><span class="option-text">{{ option.letter }}.</span> {{ option.value }}</span>
                </b-button>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import {Storage, Project, ConflictSyn} from "../../../core/Utils"
    import Steps from "../Utils/steps";
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"

    const Options = Object.freeze({
        FIRSTOPTION: 0,
        SECONDOPTION: 1,
        THIRDOPTION: 2,
    })

    export default {
        name: "RapidExperimentsWithCustomers23",
        components: {ProjectStepContainer},
        props: ['items'],
        data() {
            return {
                step: Steps.FORM_OPTION,
                form: {
                    option: {},
                },
                index: '',
                options: [
                    {"key": 0, "letter": "A", "value": "The idea we tested was a hit!"},
                    {"key": 1, "letter": "B", "value": "We confirmed this is a problem worth solving, but the solution we tested didn’t work out."},
                    {"key": 2, "letter": "C", "value": "It turns out this isn’t a problem worth solving."},
                ]
            }
        },
        created() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            select(num) {
                const form = this.form
                form.option = this.options.filter((option, i) => option.key == num)[0];
            },
            redirection() {
                const index = this.$route.params.index
                if (this.form.option.key === 0) {

                    this.$router.push({name: 'finish_24', params: {index}})
                } else if (this.form.option.key === 1) {

                    this.$router.push({name: 'finish_start_new_project_25', params: {index}})
                } else if (this.form.option.key === 2) {

                    this.$router.push({name: 'finish_start_new_project_25', params: {index}})
                }
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
        },
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .font-size
       .square
          height auto !important

    .button-row-cover
        margin-top -20px
        padding-bottom 28px

    .disabledButton
        border: 1px solid #999999
        background-color: #cccccc
        color: #666666
        pointer-events: none

    +for_breakpoint(xs)
        .font-size
            .emotion-content
                padding-right: 2px !important
                padding-left: 2px !important

    +for_breakpoint(xs)
        .font-size
            .emotion-content
                padding-right: 2px !important
                padding-left: 2px !important

    +for_breakpoint(xs)
        .text-two
            height 95px !important
            padding-top 10px

    .high-contrast
        .square
            border 1px solid color-4
            box-shadow(0px 1px 5px color-16)
            color black

            &:hover
                border solid 1px color-29

            &.active
                background-color color-29
                color white

    .other-emotion
        font font-sourcesans-bold
        font-size 14px
        color black

    .option-text
        font-sourcesans-regular
        font-size 16px
        color color-5

    .square
        font-family 'Source Sans Pro', sans-serif
        font-size 16px
        font-weight 400
        color color-4
        border-radius 10px
        box-shadow(0px 1px 5px color-16)
        height 69px
        margin-top 15px
        text-align: left !important;

        &:hover
            border solid 1px color-5

        &.active
            background-color color-5
            color white !important

            .option-text
                color white

    .table-t
        display table
        height 69px
        width 100%

    .text-t
        display table-cell
        vertical-align middle
        padding-left 30px
        padding-right 26px

    .text-two
        height 75px !important
        padding-top 1px

</style>
